<!-- Slideout setting section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title" cvLocalizedText langSection="Report_Widget" langKey="Reporting">
        <!-- The header of this section -->
        Reporting
    </div>
    <div *ngIf="selectedReport" class="custom-setting-section-context">
        <!-- Context beneath the header, usually showing an overview of what is selected without expanding the section -->
        {{ selectedReport?.DisplayName ?? "" }} ({{ selectedDateField?.displayName ?? ""}})
    </div>
    <div class="custom-setting-section-body">
        <!-- The controls to change settings, will be shown when the section is expanded -->
        <!-- <cv-single-select *ngIf="definitions !== null"
            [id]="(stateKey + '_temp' + 'ReportSettings-Select-Report') | cleanId"
            [search]="false"
            [options]="definitions"
            [value]="selectedReport"
            (valueChange)="onReportChanged($event)"
            primaryKey="_id"
            label="displayName"
            [selectionText]="selectedReport.displayName"
        ></cv-single-select> -->
        
        <div *ngIf="definitions !== null" class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Report_Widget" langKey="Report">Report</div>
        <select *ngIf="definitions !== null" class="form-control mb-3" [(ngModel)]="selectedReport" (change)="onReportSelected()">
            <option *ngFor="let rs of definitions" [ngValue]="rs">{{ rs.ReportingSetDefinition.DisplayName }}</option>
        </select>
        <div *ngIf="dates !== null" class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Report_Widget" langKey="Date_Field">Date Field</div>
        <select *ngIf="dates !== null" class="form-control mb-3" [(ngModel)]="selectedDateField" (change)="onDateSelected()">
            <option *ngFor="let d of dates" [ngValue]="d">{{ d.displayName }}</option>
        </select>
    </div>
</cv-module-custom-setting-section>

<!-- CXOne modal setting section -->
<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group" cvModuleCxoneCustomSettingSection position="top" [moduleManager]="moduleManager">
        <label cvLocalizedText langSection="Report_Widget" langKey="Report">Report</label>
        <cxone-singleselect-dropdown
            [placeholder]="getLocalizedText('Select_Report')"
            *ngIf="definitions !== null"
            [(ngModel)]="selectedReport" 
            [options]="reportOptions" 
            [label]="'DisplayName'" 
            [primaryKey]="'_id'"
            (selectionChanged)="onReportSelected()">
        </cxone-singleselect-dropdown>
        <cv-reportingset-dynamic-filters 
            *ngIf="selectedReport?.ReportFilterableFields != undefined && !refreshFilters" 
            [externalReportFilterableFields]="getSelectedReportFilterableFieldsCopy()" 
            [moduleManager]="moduleManager" 
            [selectedReportID]="selectedReport._id">
        </cv-reportingset-dynamic-filters>
        <label *ngIf="dates?.length > 0 && dates !== null" style="margin-top: 1rem;" cvLocalizedText langSection="Report_Widget" langKey="Date_Field">Date Field</label>
        <cxone-singleselect-dropdown
            *ngIf="dates !== null && dates?.length > 0"
            [placeholder]="getLocalizedText('Select_Date_Field')"
            [(ngModel)]="selectedDateField"
            [options]="dates"
            [label]="'displayName'"
            [primaryKey]="'name'"
            (selectionChanged)="onDateSelected()">
        </cxone-singleselect-dropdown>
        <label *ngIf="fieldDefinitions?.length > 0 && selectedReportApiModel?.SupportsGrouping" style="margin-top: 1rem;" cvLocalizedText langSection="Report_Widget" langKey="Group_Rows_By">Group rows by</label>
        <cxone-singleselect-dropdown
            *ngIf="fieldDefinitions !== null && fieldDefinitions?.length > 0"
            [(ngModel)]="selectedGroupByRow"
            [options]="fieldDefinitions"
            [label]="'DisplayName'"
            [primaryKey]="'ColumnField'"
            [isRequired]="true"
            (selectionChanged)="onGroupByRowSelected()">
        </cxone-singleselect-dropdown>
    </div>
</ng-container>
